import { Component } from '@theme/component';

class VPProductDetail extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updateSummary();
  }

  updatedCallback() {
    super.updatedCallback();
    this.updateSummary();
  }

  updateSummary() {
    const output = this.querySelector('[data-selection-summary]');
    if (!output) return;
    const fields = Array.from(this.querySelectorAll('[data-summary-field]'));
    const parts = fields.flatMap((field) => {
      if (field instanceof HTMLInputElement && field.type === 'radio' && !field.checked) return [];
      const value = field.value.trim();
      if (!value) return [];
      if (field.hasAttribute('data-quantity')) {
        return field.validity.valid ? [value + ' ' + this.dataset.pcs] : [];
      }
      return [value];
    });
    const next = parts.join(' · ');
    if (output.textContent !== next) output.textContent = next;
  }
}

if (!customElements.get('vp-product-detail')) customElements.define('vp-product-detail', VPProductDetail);
